/**
 * Lightweight in-app navigation tracker.
 * Tracks whether the user has navigated within the app (via client-side routing)
 * so that back-navigation hooks can safely use window.history.back().
 *
 * Uses a module-level counter that resets on full page reload — this is intentional,
 * since a full reload means the browser history may contain external entries.
 */

let inAppNavCount = 0;

export function recordNavigation() {
  inAppNavCount++;
}

export function hasInAppHistory(): boolean {
  return inAppNavCount > 0;
}
